import { Component, Input } from '@angular/core';
import { Platform, LoadingController, Loading, AlertController } from 'ionic-angular';
import { Storage } from "@ionic/storage";
import { AssetService } from '../../services/asset.service';
import { Asset,PointCategory } from '../../models/asset.model';
import { ISubscription } from 'rxjs/Subscription';
import { TrendService } from '../../services/trend.service'
import { Trend } from '../../models/trend.model';
import { SystemService } from '../../services/system.service';
import { PointService } from '../../services/point.service';
import { Console } from '@angular/core/src/console';
import { SecurityConfiguration } from '../../security/security.configuration';
import { AuthConfig } from 'angular-oauth2-oidc';
import { LoginService } from '../../pages/login/login.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { TranslateService } from "@ngx-translate/core";


declare let ga: any;

@Component({
  selector: 'trends',
  templateUrl: 'trends.html',
  providers: [TranslateService]
  // providers:[OAuthService]
})
export class TrendsComponent {
  private subscription: ISubscription;
  public access_token: string;
  public asset: Asset;
  public points: PointCategory[] = [];
  public pointName: string;
  public pontname1:string;
  public duration: number;
  public trends: Trend[];
  public fetchDataSpinner: Loading;
  public showGetData: boolean = false;
  public showPointsData: boolean = false;
  public showGridData: boolean = false;
  public pointId: string;
  public lan:string;
  public selectedPointName: string;
  public PointsDatatype:string;
  public spinnerOptions = {
    content: this.translate.instant('Fetchingdata'),
    spinner: 'bubbles'
  }
  public username: string;

  constructor(
    private platform: Platform,
    private storage: Storage,
    public assetService: AssetService,
    public trendService: TrendService,
    private loadingCtrl: LoadingController,
    private systemsService: SystemService,
    private pointService: PointService,
    private securityConfig: SecurityConfiguration,
    private alertCtrl:AlertController,
    private loginService:LoginService,
    private _oAuthService: OAuthService,
    public translate: TranslateService
  ) {
    this.asset = this.assetService.get();
    this.pointName = "Overview";
    this.pontname1 = this.translate.instant('OVERVIEW')
    let period=+sessionStorage.getItem('trendsTimeDuration');
      this.duration=period;
    
  }
  ngOnInit() {
    this.lan =sessionStorage.getItem("lang")
    // this.lan="cn";
    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.access_token = sessionStorage.getItem('access_token');
      this.getCategoryPoints(this.access_token, this.asset.id, this.duration);
      let isOnboardDiagnostics = sessionStorage.getItem('isOnboardDiagnostic');
      if(isOnboardDiagnostics == '1'){
        sessionStorage.setItem('isOnboardDiagnostic', '0');
        this.pointName = "Onboard Diagnostics"
    this.pontname1 = this.translate.instant('OnboardDiagnostics')
      }
      this.getTrendCharts(this.access_token, this.asset.id, this.pointName, this.duration); 
      this.username = JSON.parse(sessionStorage.getItem('id_token_claims_obj')).globalid;
      this.username = this.username.replace("~AAD:","");
      ga('set', 'title', 'Trends'); 
      ga('set', 'page', '/mobile/assets/trends');
      ga('set', 'dimension1', this.username);
      ga('set', 'dimension2', this.asset.id); 

      ga('send', 'pageview');
    }
    else {
      this.storage.get('access_token').then((token) => {
        this.access_token = token;
        this.getCategoryPoints(this.access_token, this.asset.id, this.duration);
        this.getTrendCharts(this.access_token, this.asset.id, this.pointName, this.duration);
      });
    }

  }

  getCategoryPoints(token, assetId, duration) {
    this.trendService.getPointsCategoryNames(token, assetId, duration,this.lan)
      .subscribe((data) => {
        data = data.filter(el => el.categoryName.toLowerCase().indexOf('sales') < 0);
        this.points = data;
      });
  }

  getTrendCharts(token, assetId, pointName, duration) {
    if(this._oAuthService.hasValidAccessToken()){
    this.fetchDataSpinner = this.loadingCtrl.create(this.spinnerOptions);
    this.fetchDataSpinner.present();
    this.subscription = this.trendService.getTrendChart(token, assetId, pointName, duration,this.lan)
      .subscribe((data) => {
        if (data && data.length > 0) {
          this.trends = data;
          this.fetchDataSpinner.dismiss();
        }
      }, (error) => this.fetchDataSpinner.dismiss());
    }
    else{
      let alert = this.alertCtrl.create({
        subTitle: 'Session expired',
        buttons: [
          {
            text:'OK',
            handler:()=>{
              this.securityConfig.logout();
            }
          }],
        enableBackdropDismiss: false
    });
    alert.present();
    }


  }

  ngOnDestroy() {
    if (!this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }

  selectTimeDuration(event) {
    this.showGetData = false;
    this.trends = undefined;
    this.duration = event;
    this.getTrendCharts(this.access_token, this.asset.id, this.pointName, this.duration);
  }

  changeSystem(asset) {
    this.showGetData = false;
    this.trends = undefined;
    this.asset = asset;
    this.systemsService.set(false);
    this.getTrendCharts(this.access_token, this.asset.id, this.pointName, this.duration);
  }

  changePoint(point) {
    this.showGetData = false;
    this.pointName = point;
    this.pointService.set(false);
    this.getTrendCharts(this.access_token, this.asset.id, this.pointName, this.duration);
  }

  openPointCategories() {
    this.systemsService.set(false);
    this.pointService.set(true);
  }

  pointClick(event) {
    let screenWidth, screenHeight;

    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      screenWidth = document.documentElement.clientWidth, window.innerWidth || 0;
      screenHeight = document.documentElement.clientHeight, window.innerHeight || 0;
    }

    this.showGetData = false;
    this.showGetData = true;
    let mouseEvent = event[2];
    setTimeout(function () {
      let div = document.getElementsByClassName('get-data-block')[0];
        let diffX = screenWidth - mouseEvent.x;
        let diffY = screenHeight -mouseEvent.y;
        if(mouseEvent.x >= (screenWidth /2)){
          (div as any).style.left = (mouseEvent.x - 200) + "px";
        }
        else{
          (div as any).style.left = (mouseEvent.x - 50) + "px"; 
        }      
        if(mouseEvent.y >= (screenHeight /2)){        
          (div as any).style.top = (mouseEvent.y - 140) + "px";
        }
        else{
          (div as any).style.top = mouseEvent.y + "px";
        }
        
    }, 5);
  }

  hideDiv() {
    this.showGetData = false;
  }

  showPoints(event){
    this.showGetData = false;
    this.showPointsData = event;
  }
  showGrid(event){
    this.showGridData = event[0];
    this.pointId = event[1];
    this.selectedPointName = event[2];
    this.PointsDatatype=event[3]
  }

  hideGrid(event){
    this.showGridData = event;
  }

  enableZoom(event){
    event.isZoomed = !event.isZoomed;
  }
}



// WEBPACK FOOTER //
// ./src/components/trends/trends.ts